import axios from "axios";
import { api_url } from "../constant";

const Client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem('token')?.replace('"', '') || ""
    }
});

export default Client;
